import axios from 'axios'

import { API_URL } from '../../Env'

const GetCountries = () => {
    return axios.get(`${API_URL}/countries`);
}

const CountriesAPI = {
    GetCountries
}

export default CountriesAPI;